import { jsxs as a, jsx as l } from "react/jsx-runtime";
import { CloseIcon as t } from "../../../assets/svgs/CloseIcon.js";
const r = ({
  closeModal: d,
  title: s,
  genericTaggingEvent: o
}) => /* @__PURE__ */ a("div", { className: "modal-title-container", children: [
  /* @__PURE__ */ l("h1", { className: "modal-title", children: s }),
  /* @__PURE__ */ l(
    "button",
    {
      onClick: () => {
        o == null || o("discount_coupon", {
          name: "Modal fechado no X"
        }), d();
      },
      className: "modal-close-icon",
      "data-testid": "close-button",
      children: /* @__PURE__ */ l(t, {})
    }
  )
] });
export {
  r as ModalHeader
};
